export default __webpack_public_path__ + "static/media/post-3.82cf9e60.png";